import o from "./highrise1579.mjs";
import a from "./highrise1580.mjs";
import i from "./highrise1581.mjs";
function f(r) {
  return a(r) ? i(r) : o(r);
}
export {
  f as default
};
